// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__c0Q1z","top":"Footer_top__Ua30g","column":"Footer_column__vX8Wv","bottom":"Footer_bottom__syzdZ"};